import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'RemoveUnderscore'
})
export class RemoveUnderscorePipe implements PipeTransform {

    transform(value: string, args?: any): string {
        return value.replace(/_/g, ' ');
    }

}